
import { Vue, Prop, Component } from "vue-property-decorator";
import ShiftMembers from './shift-members.model';

@Component
export default class PendingShift extends Vue {
    @Prop() id!: string;
    @Prop() username!: string;
    @Prop() scheduleId!: string;
    @Prop() assignmentId!: string;   
    @Prop() date!: Date;
    @Prop() startTime!: Date;
    @Prop() endTime!: Date;
    @Prop() departmentShiftId!: number;
    @Prop() tenantId !: string;
    @Prop() departmentId !: number;
    @Prop() staffId !: number;
    @Prop() skillId!: number;
    @Prop() shiftCode!: string;
    @Prop() skill!: string;
    @Prop() shiftMembers!: ShiftMembers[];
    @Prop() actualStartTime!: string;
    @Prop() actualEndTime!: string;
    @Prop() actionableBy!: Date;
}
